export class EnterpriseDashboardBudgetGroupedContract {
	/** Set by the datagrid when used as a grid row for a unique key. */
	public id?: string;

	public originContractId: string;
	public dbaName: string;
	public prevBudgetCost: number;
	public actualCost: number;
	public nextBudgetCost: number;
	public varianceAmount: number;
	public variancePercent: number;
	public nextBudgetCostDiffPercent: number;

	constructor(data?: Partial<EnterpriseDashboardBudgetGroupedContract>) {
		if (data) {
			Object.assign(this, data);
		}
	}
}
